/**
 * Theme Override JavaScript
 * Ce fichier est automatiquement inclus sur toutes les pages du thème
 * Utilisez-le pour ajouter du JavaScript personnalisé ou modifier le comportement du thème
 *
 * === CONFIGURATION CATALOGUE AUTOMATIQUE ===
 *
 * Pour configurer l'ajout automatique du catalogue gratuit :
 *
 * 1. Créez vos produits "Catalogue" dans votre admin Shopify :
 *    - Un catalogue par locale ou groupe de locales
 *    - Prix = 0,00 €
 *    - Décochez "Cet article est un produit physique" (pas de frais de port)
 *    - Masquez-les des collections et recherche
 *    - Configurez le stock pour ne pas le suivre
 *
 * 2. Récupérez les variant IDs de chaque produit catalogue
 *
 * 3. Configurez CATALOG_CONFIG ci-dessous avec vos variant IDs :
 *    - Modifiez les valeurs dans catalogsByLocale
 *    - Définissez le defaultCatalog (fallback)
 *    - Utilisez null pour qu'une locale n'ait pas de catalogue
 *
 * 4. Ou utilisez la console pour configuration dynamique :
 *    // Configuration par locale individuelle
 *    window.theme.override.setCatalogForLocale('fr', 12345);
 *    window.theme.override.setCatalogForLocale('de', 23456);
 *    window.theme.override.setCatalogForLocale('en', null); // Pas de catalogue pour anglais
 *    window.theme.override.setDefaultCatalog(12345);
 *
 *    // Configuration en lot
 *    window.theme.override.setCatalogConfig({
 *      catalogsByLocale: {
 *        'fr': 12345,
 *        'de': 23456,
 *        'it': 34567,
 *        'es': 45678,
 *        'pt-pt': 56789,
 *        'en': null    // Pas de catalogue pour l'anglais
 *      },
 *      defaultCatalog: 12345
 *    });
 *
 * 5. Fonctions utiles pour debug/test :
 *    window.theme.override.getCatalogConfig();  // Voir la config actuelle
 *    window.theme.override.testLocale('pt-PT'); // Tester une locale
 *    window.theme.override.debugCart();         // Debug du panier
 *    window.theme.override.checkCatalog();      // Forcer vérification
 *
 * Le système ajoute automatiquement le bon catalogue selon la langue du client
 * avec fallback sur le catalogue par défaut si aucun catalogue spécifique trouvé.
 */

(function() {
  'use strict';

  // Vérifie que le thème principal est chargé
  if (typeof window.theme === 'undefined') {
    window.theme = {};
  }

  // Namespace pour vos overrides
  window.theme.override = window.theme.override || {};

  /**
   * Configuration des catalogues gratuits selon la locale
   */
  const CATALOG_CONFIG = {
    // Configuration des catalogues par locale
    // TODO: Remplacez les IDs de test par les vrais variant IDs
    catalogsByLocale: {
      'fr': 52199333101897,    // Variant ID du catalogue français (défaut)
      'de': null,    // Variant ID du catalogue allemand
      'it': 52199333101897,    // Variant ID du catalogue italien
      'es': 52199333200201,    // Variant ID du catalogue espagnol
      'pt-pt': 52199333200201, // Variant ID du catalogue portugais
      'pt': 52199333200201     // Alias pour pt-PT
    },

    // Catalogue par défaut (fallback) - utilisé si aucun catalogue spécifique n'est trouvé
    // Mettez null si vous ne voulez pas de catalogue par défaut
    defaultCatalog: 52199333101897, // Par défaut = français

    // Options de validation
    skipValidation: false, // Mettez true pour bypasser la validation des variant IDs

    // Fonction pour obtenir le variant ID selon la locale avec fallback
    getCatalogVariantId: function(locale) {
      const normalizedLocale = locale.toLowerCase();

      // Recherche exacte d'abord
      if (this.catalogsByLocale.hasOwnProperty(normalizedLocale)) {
        const variantId = this.catalogsByLocale[normalizedLocale];
        if (variantId === null) {
          console.log(`[Auto Catalog] Locale "${locale}" configurée pour ne pas avoir de catalogue`);
          return null;
        }
        return variantId;
      }

      // Essaie avec le code de langue principal (ex: pt-PT -> pt)
      const languageCode = normalizedLocale.split('-')[0];
      if (this.catalogsByLocale.hasOwnProperty(languageCode)) {
        const variantId = this.catalogsByLocale[languageCode];
        if (variantId === null) {
          console.log(`[Auto Catalog] Langue "${languageCode}" configurée pour ne pas avoir de catalogue`);
          return null;
        }
        return variantId;
      }

      // Fallback sur le catalogue par défaut
      if (this.defaultCatalog === null) {
        console.log(`[Auto Catalog] Aucun catalogue trouvé pour "${locale}" et pas de fallback configuré`);
        return null;
      }

      console.log(`[Auto Catalog] Aucun catalogue trouvé pour "${locale}", utilisation du fallback`);
      return this.defaultCatalog;
    },

    // Obtient tous les variant IDs de catalogues configurés
    getAllCatalogVariantIds: function() {
      const allIds = Object.values(this.catalogsByLocale).filter(id => id !== null);
      // Ajoute le défaut s'il n'est pas déjà dans la liste et s'il n'est pas null
      if (this.defaultCatalog !== null && !allIds.includes(this.defaultCatalog)) {
        allIds.push(this.defaultCatalog);
      }
      // Supprime les doublons
      return [...new Set(allIds)];
    },

    // Fonction utilitaire pour obtenir des informations de debug
    getDebugInfo: function() {
      return {
        catalogsByLocale: this.catalogsByLocale,
        defaultCatalog: this.defaultCatalog,
        allVariantIds: this.getAllCatalogVariantIds()
      };
    }
  };

  /**
   * Récupère le panier actuel via l'API Shopify
   */
  async function getCart() {
    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      });

      if (!response.ok) {
        throw new Error('Erreur lors de la récupération du panier: ' + response.status);
      }

      return await response.json();
    } catch (error) {
      console.error('[Auto Catalog] Erreur getCart:', error);
      return null;
    }
  }

  /**
   * Valide qu'un variant ID existe en cherchant dans TOUS les produits
   */
  async function validateVariantId(variantId, skipValidation = false) {
    if (skipValidation) {
      console.log(`[Auto Catalog] Validation bypassée pour ${variantId}`);
      return true;
    }

    try {
      console.log(`[Auto Catalog] Recherche du variant ${variantId} dans tous les produits...`);

      // Récupère tous les produits (par pages de 250)
      let page = 1;
      let foundVariant = false;

      while (page <= 4 && !foundVariant) { // Max 1000 produits
        const response = await fetch(`/products.json?limit=250&page=${page}`);
        if (!response.ok) break;

        const data = await response.json();
        if (!data.products || data.products.length === 0) break;

        console.log(`[Auto Catalog] Recherche page ${page} - ${data.products.length} produits`);

        // Cherche le variant dans tous les produits de cette page
        for (const product of data.products) {
          const variant = product.variants?.find(v => v.id === variantId);
          if (variant) {
            console.log(`[Auto Catalog] ✅ Variant ${variantId} trouvé !`);
            console.log(`[Auto Catalog] Produit: ${product.title}`);
            console.log(`[Auto Catalog] Variant: ${variant.title}`);
            console.log(`[Auto Catalog] Prix: ${variant.price} - Disponible: ${variant.available}`);

            if (!variant.available) {
              console.warn(`[Auto Catalog] ⚠️ Variant trouvé mais non disponible`);
              return false;
            }

            return true;
          }
        }

        page++;
      }

      console.error(`[Auto Catalog] ❌ Variant ${variantId} non trouvé dans ${(page-1)*250} produits`);
      return false;

    } catch (error) {
      console.warn('[Auto Catalog] Erreur lors de la validation du variant:', error);
      return true; // En cas d'erreur, on essaie quand même l'ajout
    }
  }

  /**
   * Ajoute un produit au panier
   */
  async function addToCart(variantId, quantity = 1) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity }]
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        console.warn(`[Auto Catalog] Impossible d'ajouter l'article (${response.status})`, responseData);

        // Gestion spécifique des erreurs 422
        if (response.status === 422) {
          if (responseData.message && responseData.message.includes('sold out')) {
            console.warn('[Auto Catalog] Article non disponible');
          } else if (responseData.message && responseData.message.includes('does not exist')) {
            console.warn('[Auto Catalog] Article non trouvé');
          }
        }

        return null;
      }

      return responseData;
    } catch (error) {
      console.error('[Auto Catalog] Erreur addToCart:', error);
      return null;
    }
  }

  /**
   * Met à jour les quantités dans le panier
   */
  async function updateCartItems(updates) {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates: updates })
      });

      if (!response.ok) {
        throw new Error('Erreur lors de la mise à jour du panier: ' + response.status);
      }

      return await response.json();
    } catch (error) {
      console.error('[Auto Catalog] Erreur updateCartItems:', error);
      return null;
    }
  }

  /**
   * Détecte la locale actuelle du site
   */
  function getCurrentLocale() {
    let currentLocale = 'fr'; // Valeur par défaut

    try {
      // 1. Essaie d'abord de récupérer depuis Shopify global
      if (window.Shopify && window.Shopify.locale) {
        currentLocale = window.Shopify.locale.toLowerCase();
      }
      // 2. Essaie depuis l'attribut lang du document (préserve les formats comme pt-PT)
      else if (document.documentElement.lang) {
        currentLocale = document.documentElement.lang.toLowerCase();
      }
      // 3. Essaie depuis une variable dans le HTML (souvent injectée par Liquid)
      else if (window.theme && window.theme.locale) {
        currentLocale = window.theme.locale.toLowerCase();
      }
      // 4. Essaie de récupérer depuis l'URL ou un meta tag
      else {
        const metaLocale = document.querySelector('meta[name="locale"]');
        if (metaLocale) {
          currentLocale = metaLocale.content.toLowerCase();
        } else {
          // Dernière tentative : analyser l'URL pour détecter un préfixe de langue
          const pathParts = window.location.pathname.split('/');
          if (pathParts.length > 1) {
            const urlLocale = pathParts[1].toLowerCase();
            // Vérifie si c'est une locale supportée (incluant pt-pt)
            const supportedLocales = ['fr', 'de', 'es', 'it', 'en', 'pt', 'pt-pt'];
            if (supportedLocales.includes(urlLocale)) {
              currentLocale = urlLocale;
            }
          }
        }
      }

      // Normalisation spéciale pour le portugais
      if (currentLocale === 'pt-br') {
        console.log('[Auto Catalog] Détection pt-BR, conversion vers pt-PT');
        currentLocale = 'pt-pt';
      }

    } catch (error) {
      console.warn('[Auto Catalog] Impossible de détecter la locale, utilisation de FR par défaut');
    }

    return currentLocale;
  }

  /**
   * Vérifie et gère l'ajout automatique du catalogue selon la locale
   */
  async function manageCatalogInCart() {
    const currentLocale = getCurrentLocale();

    const targetVariantId = CATALOG_CONFIG.getCatalogVariantId(currentLocale);

    if (targetVariantId === null) {

      // Supprime tous les catalogues existants car cette locale ne doit pas en avoir
      const cart = await getCart();
      if (!cart) {
        console.error('[Auto Catalog] Impossible de récupérer le panier');
        return;
      }

      const allCatalogIds = CATALOG_CONFIG.getAllCatalogVariantIds();
      const catalogsInCart = cart.items.filter(item =>
        allCatalogIds.includes(item.variant_id)
      );

      if (catalogsInCart.length > 0) {
        const updates = {};
        catalogsInCart.forEach(item => {
          updates[item.key] = 0;
        });

        const updateResult = await updateCartItems(updates);
        if (updateResult) {
          // Force le refresh du cart drawer
          forceCartRefresh();

          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: {
              catalogAutoAdded: true,
              locale: currentLocale,
              action: 'removed'
            }
          }));
        }
      }
      return;
    }

    const cart = await getCart();

    if (!cart) {
      console.error('[Auto Catalog] Impossible de récupérer le panier');
      return;
    }

    // Vérifie quels catalogues sont présents dans le panier
    const allCatalogIds = CATALOG_CONFIG.getAllCatalogVariantIds();
    const catalogsInCart = cart.items.filter(item =>
      allCatalogIds.includes(item.variant_id)
    );

    const hasCorrectCatalog = catalogsInCart.some(item =>
      item.variant_id === targetVariantId
    );

    const wrongCatalogs = catalogsInCart.filter(item =>
      item.variant_id !== targetVariantId
    );

    let cartUpdated = false;

    // Supprime les mauvais catalogues (si la locale a changé)
    if (wrongCatalogs.length > 0) {
      const updates = {};
      wrongCatalogs.forEach(item => {
        updates[item.key] = 0;
      });

      const updateResult = await updateCartItems(updates);
      if (updateResult) {
        cartUpdated = true;
      }
    }

    // Compte les articles hors catalogues
    const nonCatalogItems = cart.items.filter(item =>
      !allCatalogIds.includes(item.variant_id)
    );

    // Ajoute le bon catalogue seulement s'il y a des articles non-catalogue dans le panier
    if (!hasCorrectCatalog && nonCatalogItems.length > 0) {
      const addResult = await addToCart(targetVariantId, 1);

      if (addResult) {
        cartUpdated = true;
      }
    }

    // Déclenche un événement pour notifier les autres composants et forcer le refresh
    if (cartUpdated) {
      // Force le refresh du cart drawer et de tous les éléments du panier
      forceCartRefresh();

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: {
          catalogAutoAdded: true,
          locale: currentLocale
        }
      }));
    }
  }

  /**
   * Initialisation des overrides
   */
  function initOverrides() {
    // Initialise la gestion automatique du catalogue
    initAutoCatalog();
  }

  /**
   * Initialise la gestion automatique du catalogue
   */
  function initAutoCatalog() {
    // Vérifie le catalogue immédiatement au chargement de la page
    setTimeout(manageCatalogInCart, 1000);

    // Écoute les événements du panier pour vérifier le catalogue
    const cartEvents = [
      'cart:updated',
      'cart:change',
      'ajaxProduct:added',
      'variant:changed'
    ];

    cartEvents.forEach(eventName => {
      document.addEventListener(eventName, function(event) {
        // Évite les boucles infinies en vérifiant si c'est notre propre événement
        if (event.detail && event.detail.catalogAutoAdded) {
          return;
        }

        // Délai pour permettre au panier de se mettre à jour
        setTimeout(manageCatalogInCart, 500);
      });
    });

    // Écoute les changements de quantité dans le panier
    const qtySelectors = [
      'input[name="updates[]"]',
      'input[name="quantity"]',
      '.quantity__input',
      '.ajaxcart__qty',
      '.qty'
    ].join(',');

    document.addEventListener('change', function(event) {
      if (event.target.matches(qtySelectors)) {
        setTimeout(manageCatalogInCart, 500);
      }
    });

    // Écoute les ouvertures du cart drawer ou de la page panier
    document.addEventListener('click', function(event) {
      // Détecte les clics sur les éléments qui ouvrent le panier
      if (event.target.matches('.cart-link, .cart-toggle, [data-cart-toggle]') ||
          event.target.closest('.cart-link, .cart-toggle, [data-cart-toggle]')) {
        setTimeout(manageCatalogInCart, 300);
      }
    });

    // Écoute les changements de locale/langue
    const langSwitchers = [
      '.lang-switch',
      '.locale-selector',
      '[data-locale]',
      '.currency-selector'
    ].join(',');

    document.addEventListener('change', function(event) {
      if (event.target.matches(langSwitchers)) {
        setTimeout(manageCatalogInCart, 1000);
      }
    });
  }

  /**
   * Force le refresh du cart drawer et de tous les éléments du panier
   */
  function forceCartRefresh() {
    try {
      // Méthode 1: Utilise la fonction buildCart du thème si disponible
      if (window.theme && window.theme.CartForm && window.theme.cartForm) {
        window.theme.cartForm.buildCart();
      }

      // Méthode 2: Force le rebuild du cart drawer si disponible
      if (window.theme && window.theme.CartDrawer && window.theme.cartDrawer) {
        if (window.theme.cartDrawer.cartForm && window.theme.cartDrawer.cartForm.buildCart) {
          window.theme.cartDrawer.cartForm.buildCart();
        }
      }

      // Méthode 3: Recherche et déclenche buildCart sur tous les formulaires de panier
      const cartForms = document.querySelectorAll('#CartDrawerForm, #CartPageForm, form[data-location]');
      cartForms.forEach(form => {
        if (form._cartForm && typeof form._cartForm.buildCart === 'function') {
          form._cartForm.buildCart();
        }
      });

      // Méthode 4: Déclenche les événements que le thème écoute
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }, 100);

    } catch (error) {
      console.warn('[Auto Catalog] Erreur lors du refresh du panier:', error);
    }
  }

  /**
   * Fonction utilitaire pour déboguer le panier
   */
  function debugCart() {
    getCart().then(cart => {
      if (cart) {
        console.log('[Auto Catalog Debug] Contenu du panier:', cart);
        console.log('[Auto Catalog Debug] Articles:', cart.items.map(item => ({
          id: item.variant_id,
          title: item.product_title,
          variant: item.variant_title,
          quantity: item.quantity,
          price: item.price
        })));
      }
    });
  }

  // Expose les fonctions publiques
  window.theme.override = {
    init: initOverrides,
    manageCatalogInCart: manageCatalogInCart,
    debugCart: debugCart,

    // Configuration des catalogues par locale
    setCatalogForLocale: function(locale, variantId) {
      const normalizedLocale = locale.toLowerCase();
      CATALOG_CONFIG.catalogsByLocale[normalizedLocale] = variantId;
      console.log(`[Auto Catalog] Catalogue configuré pour ${locale}:`, variantId);
    },

    // Configuration du catalogue par défaut (fallback)
    setDefaultCatalog: function(variantId) {
      CATALOG_CONFIG.defaultCatalog = variantId;
      console.log('[Auto Catalog] Catalogue par défaut configuré:', variantId);
    },

    // Configuration en lot
    setCatalogConfig: function(configObject) {
      if (configObject.catalogsByLocale) {
        Object.assign(CATALOG_CONFIG.catalogsByLocale, configObject.catalogsByLocale);
      }
      if (configObject.defaultCatalog) {
        CATALOG_CONFIG.defaultCatalog = configObject.defaultCatalog;
      }
      console.log('[Auto Catalog] Configuration mise à jour:', CATALOG_CONFIG.getDebugInfo());
    },

    // Obtient la configuration actuelle
    getCatalogConfig: function() {
      return CATALOG_CONFIG.getDebugInfo();
    },

    // Teste le système avec une locale spécifique
    testLocale: function(locale) {
      const variantId = CATALOG_CONFIG.getCatalogVariantId(locale);
      console.log(`[Auto Catalog] Locale "${locale}" → Variant ID: ${variantId}`);
      return variantId;
    },

    // Force la vérification du catalogue
    checkCatalog: function() {
      manageCatalogInCart();
    },

    // Valide tous les variant IDs configurés
    validateAllCatalogs: async function() {
      console.log('[Auto Catalog] Validation de tous les catalogues configurés...');
      const config = CATALOG_CONFIG.getDebugInfo();

      for (const [locale, variantId] of Object.entries(config.catalogsByLocale)) {
        if (variantId === null) {
          console.log(`[Auto Catalog] ${locale}: Pas de catalogue (null)`);
          continue;
        }

        console.log(`[Auto Catalog] Validation ${locale} (${variantId})...`);
        const isValid = await validateVariantId(variantId, false); // Force la validation
        console.log(`[Auto Catalog] ${locale}: ${isValid ? '✅ Valide' : '❌ Invalide'}`);
      }

      if (config.defaultCatalog) {
        console.log(`[Auto Catalog] Validation fallback (${config.defaultCatalog})...`);
        const isValid = await validateVariantId(config.defaultCatalog, false);
        console.log(`[Auto Catalog] Fallback: ${isValid ? '✅ Valide' : '❌ Invalide'}`);
      }
    },

    // Active/désactive la validation
    setValidationMode: function(enabled) {
      CATALOG_CONFIG.skipValidation = !enabled;
      console.log(`[Auto Catalog] Validation ${enabled ? 'activée' : 'désactivée'}`);
    },

    // Force le refresh du cart drawer
    refreshCartDrawer: function() {
      forceCartRefresh();
      console.log('[Auto Catalog] Refresh du cart drawer forcé');
    }
  };

  // Auto-initialisation quand le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOverrides);
  } else {
    initOverrides();
  }

})();

/**
 * Gestion AJAX des boutons "supprimer" dans le cart drawer
 */
(function() {

  function handleRemoveClick(event) {
    event.preventDefault();

    const button = event.target.closest('.cart__remove-btn');
    if (!button) return;

    const productKey = button.getAttribute('data-key');
    if (!productKey) return;

    // Désactiver le bouton pendant la requête
    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = '...';

    // Utiliser l'API AJAX du thème pour supprimer l'article (quantité = 0)
    if (window.theme && theme.cart && theme.cart.changeItem) {
      theme.cart.changeItem(productKey, 0)
        .then(function(response) {
          try {
            const cart = JSON.parse(response);

            if (cart.status === 422) {
              console.error('Erreur lors de la suppression:', cart.message);
              alert(cart.message || 'Erreur lors de la suppression de l\'article');
            } else {
              // Déclencher l'événement de mise à jour du panier pour que les autres composants se rafraîchissent
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: { cart: cart }
              }));

              // Utiliser la fonction forceCartRefresh existante qui gère tous les cas
              if (window.theme && window.theme.override && window.theme.override.forceCartRefresh) {
                window.theme.override.forceCartRefresh();
              } else {
                // Fallback: déclencher les événements que le thème écoute
                document.dispatchEvent(new CustomEvent('cart:build'));
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                document.dispatchEvent(new CustomEvent('cart:change'));
              }
            }
          } catch (e) {
            console.error('Erreur de parsing de la réponse:', e);
          }
        })
        .catch(function(error) {
          console.error('Erreur lors de la suppression:', error);
          alert('Erreur lors de la suppression de l\'article');
        })
        .finally(function() {
          // Réactiver le bouton
          button.disabled = false;
          button.textContent = originalText;
        });
    } else {
      // Fallback si l'API theme.cart n'est pas disponible
      console.warn('API theme.cart non disponible, utilisation du fallback');
      window.location.href = `/cart/change?id=${productKey}&quantity=0`;
    }
  }

  // Écouter les clics sur les boutons "supprimer" via délégation d'événements
  document.addEventListener('click', function(event) {
    if (event.target.closest('.cart__remove-btn')) {
      handleRemoveClick(event);
    }
  });

})();

// === SUBCOLLECTIONS TOGGLE FUNCTIONALITY ===
/**
 * Toggle subcollections visibility on mobile
 * @param {HTMLElement} button - The toggle button element
 */
function toggleSubcollections(button) {
  const container = button.closest('.related-collections-buttons-subcollection');
  const hiddenCollections = container.querySelectorAll('.subcollection-hidden');
  const showMoreText = button.querySelector('.show-more-text');
  const showLessText = button.querySelector('.show-less-text');
  const isExpanded = button.classList.contains('expanded');

  if (!isExpanded) {
    // Show hidden collections
    hiddenCollections.forEach((collection, index) => {
      setTimeout(() => {
        collection.style.display = 'flex';
        // Trigger animation by adding a class after display change
        requestAnimationFrame(() => {
          collection.classList.add('subcollection-animating');
        });
      }, index * 50); // Stagger the animations
    });

    // Update button state
    button.classList.add('expanded');
    showMoreText.style.display = 'none';
    showLessText.style.display = 'inline';
  } else {
    // Hide collections
    hiddenCollections.forEach((collection) => {
      collection.classList.remove('subcollection-animating');
      setTimeout(() => {
        collection.style.display = 'none';
      }, 200); // Wait for animation to complete
    });

    // Update button state
    button.classList.remove('expanded');
    showMoreText.style.display = 'inline';
    showLessText.style.display = 'none';
  }
}

// Make function globally available for onclick handlers
window.toggleSubcollections = toggleSubcollections;
